module.exports = __webpack_public_path__ + "img/character_arrow_4.65349b2d.png";